import { useEffect, useRef } from 'react'

export function useInteractionListener() {
  const interactionStart = useRef(Date.now())
  const mouseMoveCount = useRef(0)
  const keydownCount = useRef(0)
  const clickCount = useRef(0)
  const focusCount = useRef(0)
  const inputCount = useRef(0)

  const eventTarget = useRef<[number, EventTarget?]>([Date.now(), undefined])
  const timings = useRef<number[]>([])
  function recordTiming(target: EventTarget | null) {
    if (target && eventTarget.current[1] !== target) {
      const now = Date.now()
      timings.current.push(now - eventTarget.current[0])
      eventTarget.current = [now, target]
    }
  }

  useEffect(() => {
    const onMouseMove = () => {
      mouseMoveCount.current++
    }
    const onKeydown = (e: Event) => {
      keydownCount.current++
      recordTiming(e.target)
    }
    const onClick = (e: Event) => {
      clickCount.current++
      recordTiming(e.target)
    }
    const onFocus = (e: Event) => {
      focusCount.current++
      recordTiming(e.target)
    }
    const onInput = (e: Event) => {
      inputCount.current++
      recordTiming(e.target)
    }
    window.addEventListener('mousemove', onMouseMove)
    window.addEventListener('keydown', onKeydown)
    window.addEventListener('click', onClick)
    window.addEventListener('focus', onFocus)
    window.addEventListener('input', onInput)

    return () => {
      window.removeEventListener('mousemove', onMouseMove)
      window.removeEventListener('keydown', onKeydown)
      window.removeEventListener('click', onClick)
      window.removeEventListener('focus', onFocus)
      window.removeEventListener('input', onInput)
    }
  }, [])

  return {
    getInteractionState: () => ({
      durationMillis: Date.now() - interactionStart.current,
      mouseMoveCount: mouseMoveCount.current,
      keydownCount: keydownCount.current,
      clickCount: clickCount.current,
      focusCount: focusCount.current,
      inputCount: inputCount.current,
      timings: timings.current,
    }),
  }
}
